import Home from "../pages/Home"
import Contact from "../pages/Contact"

export const webPages = [
  {label:'Home', route:'/home', reactComponent: Home},
  {label:'Contact', route:'/contact', reactComponent: Contact},
]
